export const mseId = state => state.mseId
export const userName = state => state.userName



// WEBPACK FOOTER //
// ./src/store/getter.js